import script from "./VATPayments.vue?vue&type=script&setup=true&lang=ts"
export * from "./VATPayments.vue?vue&type=script&setup=true&lang=ts"

import "./VATPayments.vue?vue&type=style&index=0&id=f685267e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f685267e"]])

export default __exports__